import { Skeleton } from "src/components/Skeleton/Skeleton";

export default function SimpleRouteCardLoading() {
  return <Skeleton borderRadius="rounded_xl" height="69px" border />;
}
